<template>
  <v-container fluid>
    <PageHeading
      text="Заказы проживания"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    />
    <v-row>
      <v-col>
        <GridOrdersBooking ref="grid"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridOrdersBooking from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  components: {
    PageHeading,
    GridOrdersBooking
  },
  metaInfo () {
    return {
      title: 'Заказы проживания'
    }
  },
  mixins: [gridPageInterface]
}
</script>
